import React from "react";
import PropTypes from "prop-types";
import UserInfoTitle from "../UserInfoTitle";
import "./style.scss";

export default function UserInfo({
  children,
  name,
  email,
  icon,
  age,
  hideMatches,
  gameId,
}) {
  UserInfo.propTypes = {
    children: PropTypes.node,
    name: PropTypes.string,
    email: PropTypes.string,
    icon: PropTypes.string,
    age: PropTypes.number,
    gameId: PropTypes.number,
    hideMatches: PropTypes.bool,
  };
  return (
    <div className="info">
      <UserInfoTitle
        gameId={gameId}
        hideMatches={hideMatches}
        name={name}
        icon={icon}
        age={age}
      />
      {/*<span className="info__email">{email || ""}</span>*/}
      {children}
    </div>
  );
}
